/**
 * Mirrors EAuthErrorCode on the API.
 */
export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';
export const TWO_FACTOR_REQUIRED = 'TWO_FACTOR_REQUIRED';
export const TWO_FACTOR_PHONE_REQUIRED = 'TWO_FACTOR_PHONE_REQUIRED';

export interface IApiErrorPayload {
    statusCode?: number;
    message?: string;
    code?: string;
    email?: string;
    /** Opaque handle for an in-flight 2FA challenge. Not a session token. */
    challengeToken?: string;
    phoneHint?: string;
    /** Codes are SMS-only, so a send failure is surfaced for retry rather than
     *  silently rerouted to another channel. */
    deliveryFailed?: boolean;
}

/**
 * The account exists and the password is right, but the emailed code was never
 * used. API versions older than the `code` field only say so in the message
 * text; that fallback is skipped whenever a code is present, so a two-factor
 * response can never be mistaken for this one.
 */
export const isEmailNotVerified = (payload?: IApiErrorPayload): boolean => {
    if (payload?.code) return payload.code === EMAIL_NOT_VERIFIED;
    return (
        typeof payload?.message === 'string' &&
        payload.message.toLowerCase().includes('verify your email')
    );
};

/** Credentials accepted, second factor still owed. */
export const isTwoFactorRequired = (payload?: IApiErrorPayload): boolean =>
    payload?.code === TWO_FACTOR_REQUIRED ||
    payload?.code === TWO_FACTOR_PHONE_REQUIRED;

/** As above, but there is no verified number to send the code to yet. */
export const needsPhoneNumber = (payload?: IApiErrorPayload): boolean =>
    payload?.code === TWO_FACTOR_PHONE_REQUIRED;
